let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("45D2k")).then(() => parcelRequire('eWraG'));